<template>
  <div id="row" class="d-flex flex-column align-items-left justify-content-center">
    <div class="row1 d-flex flex-rows justify-content-between align-items-center">
      <div>
        <span class="title white">{{title.lg1}}</span>
        <span class="subtitle grey">{{subtitle.lg1}}</span>
      </div>
      <div class="price float-right white">{{price}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TribeRatesHorizontalV1RatesRow",
  props: {
    servicesLg1: Object,
  },
  computed: {
    title() {
      return {
        lg1: this.servicesLg1.label_value,
      };
    },
    subtitle() {
      return {
        lg1: this.servicesLg1.sub_label,
      };
    },
    price() {
      return this.servicesLg1.msr_value;
    },
  },
};
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_tribe.scss";

#row {
  width: 100%;
  //@include heightPercent(91);
  flex-grow: 1;
  border-bottom: 1px solid $grey;
}
</style>



// WEBPACK FOOTER //
// src/components/tribe/rates/horizontal/v1/services/rowServices.vue